import { render, staticRenderFns } from "./AddChildOrganisation.vue?vue&type=template&id=f9138ac8"
import script from "./AddChildOrganisation.vue?vue&type=script&lang=js"
export * from "./AddChildOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports